import { FunctionComponent } from 'react'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { Text } from '@conexasaude/conexa-hero'
import { Negative as NegativeIllustration } from '@conexasaude/iconography/illustrations'
import Modal from '@/components/Modal'
import useStyles from './styles'

export const MultipleScreeningAttendanceModal: FunctionComponent = () => {
  const { closeModal } = useModalContext()
  const styles = useStyles()

  return (
    <Modal
      id="MULTIPLE_SCREENING_ATTENDANCE"
      onDismiss={closeModal}
      primaryActionLabel="Voltar para o início"
      primaryAction={closeModal}
    >
      <div css={styles.contentWrapper}>
        <Text>
          {`Não é possível agendar duas consultas de triagem simultaneamente.
          Verifique suas consultas em 'Consultas'.`}
        </Text>
        <NegativeIllustration />
        <Text>Mas fique tranquilo, você poderá reagendar ou cancelar.</Text>
      </div>
    </Modal>
  )
}
